export const partnersDescription = [
    {
        id: 1,
        title: "partnersDescription.item1.title",
        content: "partnersDescription.item1.content",
        end: "partnersDescription.item1.end",
    },
    {
        id: 2,
        title: "partnersDescription.item2.title",
        content: "partnersDescription.item2.content",
        end: "partnersDescription.item2.end",
    },
];

export default partnersDescription;